import { config, embedded } from './config';

const storageKey = 'MIGRATED_BIDDING_PROCESS';

const targetLocation = embedded ? window.parent.location : window.location;

export const migratedBiddingProcess = {
    isActive: localStorage.getItem(storageKey) !== 'false',
    isVisible: true,
    activate(params: {
        slot: number;
        phase: string;
        periodType: string;
        runtimeFrom: string;
        runtimeTo: string;
        identifier: string;
        auctionId: number;
    }) {
        localStorage.removeItem(storageKey);
        targetLocation.replace(
            `${config.appBaseUrl}/transport/auctions/list?slot=${
                params.slot
            }&phase=${params.phase}&periodType=${
                params.periodType
            }&runtime-from=${params.runtimeFrom}&runtime-to=${
                params.runtimeTo
            }&identifier=${params.identifier || ''}${
                params.auctionId ? `&auctionId=${params.auctionId}` : ''
            }`
        );
    }
};
